import React from 'react'
import I18n from 'i18n-js'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'

import Pattern1 from './../../../../../../assets/images/Pattern1.png'
import Pattern2 from './../../../../../../assets/images/Pattern2.png'
import Pattern4 from './../../../../../../assets/images/Pattern3.png'
import Pattern3 from './../../../../../../assets/images/Pattern4.png'
import { H2, H3 } from '../../../../../../components/UI/index'
import styles from './ServiceCard.module.scss'
import Description from '../../../../../../components/Main/Description/Description'

const ServiceCard = (props) => {
	const { currency } = useSelector(state => state.SettingsReducer)

	const patterns = {
		1: <img src={Pattern1} className={styles.pattern}/>,
		2: <img src={Pattern2} className={styles.pattern}/>,
		3: <img src={Pattern3} className={styles.pattern}/>,
		4: <img src={Pattern4} className={styles.pattern}/>
	}

	return (
		<div className={styles.Card}>
			{/*<CardContent>*/}
			<div onClick={props.clicked}>

				<div className={styles.consultantProfileContainer}>
					<div>
						{patterns[props.service.pattern]}
					</div>
					<div>
						<div>
							<h3 className={styles.title}>{props.service.title}</h3>
						</div>
					</div>
				</div>


				<Grid item xs={12}>
					<Description description={props.service.description}/>
				</Grid>
				<Grid item xs={12}>
					<div className={styles.PriceTime}>
						<Grid item xs={6}>
							<span
								className={styles.Duration}>{props.service.duration} {I18n.t('settings.duration')}</span>
						</Grid>
						<Grid>
							{
								!!props.service.price &&
								<H3>{props.service.price} {currency === 'Rial' ? I18n.t('settings.rial') : props.service.currency}</H3>
							}
							{
								props.service.price === 0 &&
								<H3>{I18n.t('settings.free')}</H3>
							}
						</Grid>
					</div>
				</Grid>
			</div>
			{/*</CardContent>*/}
		</div>
	)
}

export default ServiceCard
